import React, { useState, useEffect } from 'react';
import { Container, Nav, Navbar, Modal, Form, Button, Row, Col, NavDropdown } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';

// img
import TopLogoDark from "../../images/logo-dark.png";
import UserImg from "../../images/user-img/1.jpg";

export default function TopMenu() {
    // Nav Link
    const [activeLink, setActiveLink] = useState('home');
    const navigate = useNavigate();
    const location = useLocation();

    // Handle dropdown navigation
    const handleDropdownNavClick = (path) => {
        navigate(path);
        setTimeout(() => {
            scrollToSection(path.substring(1));
        }, 10);
    };

    // Scroll to section by ID
    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
        }
        setActiveLink(id);
    };

    // Handle scroll events to update active link
    const handleScroll = () => {
        const sections = document.querySelectorAll('section[id]');
        let currentSection = '';
        sections.forEach(section => {
            const sectionTop = section.offsetTop;
            const sectionHeight = section.clientHeight;
            if (window.scrollY >= sectionTop - sectionHeight / 3) {
                currentSection = section.getAttribute('id');
            }
        });
        setActiveLink(currentSection);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [location]);

    // Menu sticky
    const [stickyClass, setStickyClass] = useState('');
    useEffect(() => {
        window.addEventListener('scroll', stickNavbar);
        return () => window.removeEventListener('scroll', stickNavbar);
    }, []);

    const stickNavbar = () => {
        let windowHeight = window.scrollY;
        windowHeight > 0 ? setStickyClass('sticky-nav') : setStickyClass('');
    };

    // Contact Modal
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // Form validation
    const [validated, setValidated] = useState(false);
    const handleSubmit = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        setValidated(true);
    };

    return (
        <>
            <div className='top-custom-menu'>
                <Navbar collapseOnSelect expand="lg" className={`${stickyClass}`} >
                    <Container>
                        <Link to="" className='topbar-logo'>
                            <img src={TopLogoDark} alt="" className='logo-dark' height={28} />
                        </Link>
                        <NavDropdown align={{ lg: 'start' }} title={<>
                            <div className='d-flex align-items-center'>
                                <img src={UserImg} alt="" className='avatar avatar-md rounded-circle img-thumbnail' />
                            </div>
                        </>
                        } id="basic-nav-dropdown" className='nav-user-item ms-auto d-block d-lg-none'>
                            <Link to="/" className="dropdown-item">Log Out</Link>
                        </NavDropdown>
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" className='ms-3' />
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav className="mx-lg-auto main-navbar">
                                <NavDropdown title={<>Home <i className="bi bi-chevron-down fs-15 fw-bold"></i> </>} id="home-dropdown" className={activeLink.includes('home') ? 'active' : ''}>
                                    <NavDropdown.Item onClick={() => handleDropdownNavClick('/home')} className={activeLink === 'home' ? 'active' : ''}>Home</NavDropdown.Item>
                                    <NavDropdown.Item onClick={() => handleDropdownNavClick('/home2')} className={activeLink === 'home2' ? 'active' : ''}>Home Two</NavDropdown.Item>
                                    <NavDropdown.Item onClick={() => handleDropdownNavClick('/home3')} className={activeLink === 'home3' ? 'active' : ''}>Home Three</NavDropdown.Item>
                                </NavDropdown>
                                <Nav.Link onClick={() => scrollToSection('property')} className={activeLink === 'property' ? 'active' : ''}>Property</Nav.Link>
                                <Nav.Link onClick={() => scrollToSection('about')} className={activeLink === 'about' ? 'active' : ''}>About</Nav.Link>
                                <Nav.Link onClick={() => scrollToSection('review')} className={activeLink === 'review' ? 'active' : ''}>Review</Nav.Link>
                                <Nav.Link onClick={() => scrollToSection('blog')} className={activeLink === 'blog' ? 'active' : ''}>Blog</Nav.Link>
                                <Nav.Link onClick={handleShow}>Contact Us</Nav.Link>
                            </Nav>
                            <Nav className='ms-lg-auto ms-xl-0 mt-2 mt-lg-0 mb-3 mb-lg-0 d-none d-lg-block'>
                                <NavDropdown align={{ lg: 'end' }} title={<>
                                    <div className='d-flex align-items-center'>
                                        <img src={UserImg} alt="" className='avatar avatar-md rounded-circle img-thumbnail' />
                                        <h6 className='d-none d-xl-block mb-0 ms-2'>Darryl Silver</h6>
                                    </div>
                                </>
                                } id="basic-nav-dropdown" className='nav-user-item'>
                                    <Link to="/" className="dropdown-item">Log Out</Link>
                                </NavDropdown>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>

                <Modal centered show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title className='fw-semibold text-center'>Get in Touch</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                            <Row>
                                <Form.Group as={Col} md="6" className="custom-form" controlId="firstName">
                                    <Form.Label>First name <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control required type="text" placeholder="First name..." />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="6" className="custom-form" controlId="lastName">
                                    <Form.Label>Last name <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control required type="text" placeholder="Last name..." />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="12" className="custom-form" controlId="email">
                                    <Form.Label>Email <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control required type="email" placeholder="Your email..." />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="12" className="custom-form" controlId="subject">
                                    <Form.Label>Subject <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control required type="text" placeholder="Enter Subject..." />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="12" className="custom-form" controlId="message">
                                    <Form.Label>Message <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control required as="textarea" rows={4} placeholder="Enter message..." />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                            </Row>
                            <Button type="submit" variant='outline-primary w-100'>Submit form</Button>
                        </Form>
                    </Modal.Body>
                </Modal>
            </div>
        </>
    )
}
